import React from 'react';
import { Card, Table } from 'antd';
import type { WorkstationControlCenterQueryParams } from '@/services/workstationControlCenter.service';
import { useWccCapacityForecast } from '@/hooks/useWorkstationControlCenter';

interface Props {
  params?: WorkstationControlCenterQueryParams;
}

const CapacityPlanningView: React.FC<Props> = ({ params }) => {
  const { data, isLoading } = useWccCapacityForecast(params);
  const d = data as {
    next_7_days?: Record<string, unknown>[];
    next_30_days?: Record<string, unknown>[];
  };

  const cols = [
    { title: 'WS id', dataIndex: 'workstation_id', ellipsis: true },
    { title: 'Available', dataIndex: 'available_capacity' },
    { title: 'Booked', dataIndex: 'booked_capacity' },
    { title: 'Free', dataIndex: 'free_capacity' },
    {
      title: 'Load',
      dataIndex: 'overloaded',
      render: (v: boolean, r: Record<string, unknown>) =>
        v ? 'Overloaded' : r.underloaded ? 'Underloaded' : 'OK',
    },
    { title: 'Util %', dataIndex: 'utilization_trend', width: 80 },
  ];

  return (
    <Card id="capacity-forecast" title="Capacity planning forecast" style={{ marginTop: 16 }} loading={isLoading}>
      <Table size="small" title={() => 'Next 7 days'} rowKey="workstation_id" columns={cols} dataSource={d?.next_7_days ?? []} pagination={{ pageSize: 10 }} />
      <Table size="small" title={() => 'Next 30 days'} rowKey="workstation_id" columns={cols} dataSource={d?.next_30_days ?? []} pagination={{ pageSize: 10 }} style={{ marginTop: 16 }} />
    </Card>
  );
};

export default CapacityPlanningView;
